import * as React from 'react';
import { cn } from '../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', invalid, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        aria-invalid={invalid || undefined}
        className={cn(
          'flex h-11 w-full rounded-[10px] border bg-white px-4 py-2 text-[15px]',
          'placeholder:text-ink-400 text-ink-900',
          'border-ink-200 transition-colors',
          'focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-ink-50',
          'aria-[invalid=true]:border-error-500 aria-[invalid=true]:focus:ring-error-500/20',
          className,
        )}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';
